const HomeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    width="16"
    height="16"
    fill="currentColor"
    {...props}
  >
    <path d="M541 229.16 303.1 37.81a35.2 35.2 0 0 0-38.2 0L35 229.16a35.2 35.2 0 0 0-11 38.2 35.2 35.2 0 0 0 33 22.64H96v192a32 32 0 0 0 32 32h96a32 32 0 0 0 32-32V352h64v128a32 32 0 0 0 32 32h96a32 32 0 0 0 32-32V290h38a35.2 35.2 0 0 0 33-22.64 35.2 35.2 0 0 0-11-38.2z" />
  </svg>
);

export default HomeIcon;
